import dataService from '../../data/data.service';

const state = {
  isLoggedIn: false,
  user: null

}

const getters = {
  isLoggedIn: (state) => {
    return state.isLoggedIn
  },
  user: (state) => {
    return state.user
  }
}

const actions = {
  getToken(context) {
    return new Promise(resolve => {
      dataService.modules.apiGateway.getToken().then(response => {
        resolve(response);
      })
    })
  },

  loginUser(context, user) {
    return new Promise((resolve, reject) => {
      dataService.modules.auth.loginUser(user).then(response => {
        if (response.length > 0) { //see if we got a token back.
          localStorage.setItem('token', response);
          //detect @ for email
          let params = {};
          if (/.+@.+/.test(user.userName)) {
            params.userId = user.userName;
          } else {
            params.phoneNumber = user.userName.replace(/\D+/g, '');
          }

          dataService.modules.account.get(params).then((response) => {
            context.commit('loginUser', response[0]);
            resolve();
          })
        } else {
          reject()
        }
      }, error => {
        reject(error)
      })
    });
  },

  logoutUser(context) {
    context.commit('logoutUser');
  },
}

const mutations = {
  loginUser(state, data) {
    state.isLoggedIn = true;
    state.user = data;
  },
  logoutUser(state) {
    state.isLoggedIn = false;
    state.user = null;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}